module.exports = __webpack_public_path__ + "static/media/remera.4fdb942f.webp";